const items = [
  10,
  20,
  50,
  100,
];
export default items;
